import "./index.scss"
import React from "react"

import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { Col, Button, Row, Container, Card, Form, Spinner } from "react-bootstrap"

import AppConfig from "../../config"
import AppAssets from "../../assets"

const Login = () => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [password, setPassword] = React.useState("")
  const [username, setUsername] = React.useState("")
  const navigate = useNavigate()

  const onLogin = async () => {
    try {
      setIsLoading(true)
      const res = await AppConfig.axiosInstances.Main.post(`/token/`, {
        username,
        password,
      })
      const token = res.data.access
      sessionStorage.setItem("token", token)
      setTimeout(() => {
        navigate("/")
        setIsLoading(false)
      }, 500)
    } catch (error) {
      if (error?.response?.status === 401) toast.error("Kullanıcı adı veya şifre hatalı")
      else {
        toast.error("Bir hata oluştu, kod: 10")
      }
      setIsLoading(false)
    }
  }

  const loginSubmit = (e) => {
    e.preventDefault()
    onLogin()
  }

  return (
    <div className="login-container">
      <Container>
        <Row className="vh-100 d-flex justify-content-center align-items-center">
          <Col md={8} lg={6} xs={12}>
            <Card className="shadow">
              <Card.Body>
                <div className="mb-3 mt-md-4">
                  <div className="logo-wrapper">
                    <img
                      src={AppAssets.Icons.AppLogoFullFederalBlueAndPistachioGreen}
                      alt="AppLogo"
                      className="app-logo"
                    />
                  </div>
                  <p className="mb-5">Lütfen email ve şifrenizi giriniz.</p>
                  <div className="mb-3">
                    <Form onSubmit={loginSubmit} noValidate>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className="text-center">Kullanıcı Adı</Form.Label>
                        <Form.Control type="text" onChange={(e) => setUsername(e.target.value)} value={username} />
                      </Form.Group>

                      <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Şifre</Form.Label>
                        <Form.Control type="password" onChange={(e) => setPassword(e.target.value)} value={password} />
                      </Form.Group>
                      <div className="d-grid">
                        <Button variant="primary" type="submit" disabled={isLoading}>
                          <div className="d-flex justify-content-center align-items-center">
                            {isLoading && (
                              <Spinner animation="border" variant="secondary" className="login-cta-spinner" />
                            )}
                            Giriş
                          </div>
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
export default Login
